/* PRL Co. previous-calendar-day cutoff guard. Frontend only, explicitly opt-in. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.PrlBookingDeadlineGuard) {
    root.PrlBookingDeadlineGuard = api;
    api.attach(root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var POLICY = 'previous-calendar-day-10-pt';
  var MARKER = '[data-prl-deadline-policy="' + POLICY + '"]';
  var FORM = 'form[action*="/cart/add"]';
  // Mirrors IzyRent's published add-to-cart button selectors, limited to its form.
  var BUTTON = '[name="add"],[type="submit"],button[class*="cart"],button[class*="Cart"],button[data-text*="cart"],button[data-text*="Cart"],.izyAtc';
  var ZONE = 'America/Los_Angeles';
  var formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function pacificParts(instant) {
    var p = {};
    formatter.formatToParts(new Date(instant)).forEach(function (part) {
      if (part.type !== 'literal') p[part.type] = Number(part.value);
    });
    return p;
  }
  function key(year, month, day) {
    return String(year).padStart(4, '0') + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
  }
  function addDays(dateKey, days) {
    var d = new Date(dateKey + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + days);
    return key(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate());
  }
  function minimumDateKey(instant) {
    var p = pacificParts(instant);
    return addDays(key(p.year, p.month, p.day), p.hour >= 10 ? 2 : 1);
  }
  function localDateKey(date) {
    return date && Number.isFinite(date.getTime()) ? key(date.getFullYear(), date.getMonth() + 1, date.getDate()) : null;
  }
  function localCalendarDate(dateKey) {
    var parts = dateKey.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }
  function isEligibleStart(startKey, instant) {
    return typeof startKey === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(startKey) && startKey >= minimumDateKey(instant);
  }
  function effectiveMinimumKey(nativeKey, instant) {
    var required = minimumDateKey(instant);
    // Do not relax native lead/stock/first-available restrictions. This means
    // native cross-timezone OVERBLOCKING can remain; this guard is fail-closed.
    return nativeKey && nativeKey > required ? nativeKey : required;
  }
  function nextBoundaryMs(instant) {
    var p = pacificParts(instant), dateKey = key(p.year, p.month, p.day), hour = 10;
    if (p.hour >= 10) { dateKey = addDays(dateKey, 1); hour = 0; }
    var parts = dateKey.split('-').map(Number);
    var targetWall = Date.UTC(parts[0], parts[1] - 1, parts[2], hour);
    var estimate = targetWall + 8 * 60 * 60 * 1000;
    // 00:00 and 10:00 are unambiguous Pacific times, including DST change days.
    for (var i = 0; i < 3; i += 1) {
      var actual = pacificParts(estimate);
      var actualWall = Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute, actual.second);
      estimate += targetWall - actualWall;
    }
    return Math.max(25, estimate - Number(instant) + 25);
  }

  function attach(win, options) {
    options = options || {};
    var doc = win.document;
    if (!doc || !doc.querySelector(MARKER)) return null;
    if (win.__prlDeadlineBinding) return win.__prlDeadlineBinding;
    var now = options.now || Date.now;
    var stopped = false, syncing = false, timer = null;
    var listeners = [];
    var message = 'The booking deadline for your selected start date has passed. Choose a later available date. Book before 10:00 a.m. Pacific Time on the previous day.';
    var unavailable = 'Booking dates are still loading. Please wait for the calendar and choose your dates before booking.';

    function context() {
      var marker = doc.querySelector(MARKER), calendar = doc.querySelector('#izyrent');
      var input = doc.querySelector('#startDate'), form = doc.querySelector(FORM);
      if (!marker || !calendar || !form) return null;
      return { marker: marker, input: input, fp: input && input._flatpickr, form: form };
    }
    function notify(ctx, text) {
      var status = doc.getElementById('prl-booking-deadline-status');
      if (!status) {
        status = doc.createElement('p');
        status.id = 'prl-booking-deadline-status';
        status.className = 'prl-booking-deadline-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'margin:0.75rem 0 0;color:#a81916;font-weight:600;';
        ctx.marker.appendChild(status);
      }
      status.textContent = text;
      status.hidden = !text;
    }
    function selectedStart(fp) {
      return fp.selectedDates && fp.selectedDates.length ? localDateKey(fp.selectedDates[0]) : null;
    }
    function sync() {
      if (stopped || syncing) return;
      var ctx = context();
      if (!ctx || !ctx.fp || typeof ctx.fp.set !== 'function') return;
      syncing = true;
      try {
        var instant = now(), fp = ctx.fp, start = selectedStart(fp);
        var expired = start && !isEligibleStart(start, instant);
        var originalMin = localDateKey(fp.config && fp.config.minDate);
        var requiredMin = effectiveMinimumKey(originalMin, instant);
        // Native disable rules, time slots, maxDate, minRangeDays and handlers
        // are intentionally untouched. Never manipulate disabled date classes.
        if (originalMin !== requiredMin) fp.set('minDate', localCalendarDate(requiredMin));
        if (expired) {
          if (typeof fp.clear === 'function') fp.clear();
          notify(ctx, message);
        } else if (start) notify(ctx, '');
      } finally { syncing = false; }
    }
    function schedule() {
      if (timer !== null) win.clearTimeout(timer);
      if (!stopped) timer = win.setTimeout(function () { sync(); schedule(); }, nextBoundaryMs(now()));
    }
    function refresh() { sync(); schedule(); }
    function reject(event, ctx, text) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (ctx.fp && typeof ctx.fp.clear === 'function' && text === message) ctx.fp.clear();
      notify(ctx, text);
      sync();
      return false;
    }
    function checkAction(event) {
      var ctx = context();
      if (!ctx) return;
      if (event.type === 'submit') {
        if (event.target !== ctx.form) return;
      } else {
        var target = event.target && event.target.closest && event.target.closest(BUTTON);
        if (!target || (target.form !== ctx.form && target.closest(FORM) !== ctx.form)) return;
      }
      // The capture-phase check runs before IzyRent's delegated jQuery handler,
      // even when the browser suspended the exact-boundary timer in a stale tab.
      if (!ctx.fp) return reject(event, ctx, unavailable);
      var start = selectedStart(ctx.fp);
      if (start && !isEligibleStart(start, now())) return reject(event, ctx, message);
      // Missing dates/required fields remain IzyRent's responsibility. Do not
      // enable buttons or deem the whole booking valid based only on this rule.
      sync();
    }
    function listen(target, name, handler, capture) {
      target.addEventListener(name, handler, !!capture);
      listeners.push([target, name, handler, !!capture]);
    }
    listen(doc, 'click', checkAction, true);
    listen(doc, 'submit', checkAction, true);
    listen(doc, 'izyrentReady', refresh);
    listen(doc, 'izyrentChange', sync);
    listen(doc, 'izyrentClose', sync);
    listen(doc, 'DOMContentLoaded', refresh);
    listen(doc, 'visibilitychange', function () { if (!doc.hidden) refresh(); });
    listen(win, 'focus', refresh);
    listen(win, 'pageshow', refresh);
    var binding = {
      refresh: refresh,
      stop: function () {
        stopped = true;
        if (timer !== null) win.clearTimeout(timer);
        listeners.forEach(function (listener) { listener[0].removeEventListener(listener[1], listener[2], listener[3]); });
        if (win.__prlDeadlineBinding === binding) delete win.__prlDeadlineBinding;
      }
    };
    win.__prlDeadlineBinding = binding;
    refresh();
    return binding;
  }
  return { policy: POLICY, minimumDateKey: minimumDateKey, isEligibleStart: isEligibleStart,
    effectiveMinimumKey: effectiveMinimumKey, nextBoundaryMs: nextBoundaryMs, attach: attach };
});
